module.exports = __webpack_public_path__ + "img/About_ys_big_2.0c93626a.jpg";